import { Checkbox, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, Typography, Button } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';
import ComputeIcon from '@material-ui/icons/Cached';

export default function ImpresaFamiliare(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const action = "changeImposteContributi";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }
    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }
    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraSchedaBudget(props, global, name, value, action, true);
    }

    const calcolaQuote = (e: any) => {
        props.handleChange(action, "RicalcolaQuoteCollab", true);
        API_elaboraSchedaBudget(props, global, "RicalcolaQuoteCollab", true, action, true);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;

        if (name === "F100_artigiano" && checked === true && state.imposteContributi.F101_commerciante === true)
            state.imposteContributi.F101_commerciante = false;
        else if (name === "F101_commerciante" && checked === true && state.imposteContributi.F100_artigiano === true)
            state.imposteContributi.F100_artigiano = false

        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global, name, checked, action, true);
    };


    return (
        <Paper className={gClasses.fullWidthPaper}>
            <Grid container>
                <SectionSubTitle text="Tipologia"></SectionSubTitle>
                <Grid container>
                    <FormControlLabel className={gClasses.bottomControlLabel} 
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F100_artigiano}
                                name='F100_artigiano'
                                id='F100_artigiano'
                                value={state.imposteContributi.F100_artigiano}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Artigiano"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel} 
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F101_commerciante}
                                name='F101_commerciante'
                                id='F101_commerciante'
                                value={state.imposteContributi.F101_commerciante}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Commerciante"
                    />
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="B103_ncollaboratori">N° collaboratori</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={state.imposteContributi.F103_ncollaboratori}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'F103_ncollaboratori', id: 'F103_ncollaboratori' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Divider></Divider>
            <SectionSubTitle text="Quote"></SectionSubTitle>
            <Button onClick={calcolaQuote}>
                <Typography variant="button">Calcola quote</Typography>
                <ComputeIcon style={{ color: "#009688", marginLeft: "5px", marginBottom: "5px", height: "17px" }}></ComputeIcon>
            </Button>
            <Grid container direction="column">
                <Typography style={{ marginTop: "1rem" }} variant="subtitle2">Titolare</Typography>
                <Grid container direction="row">
                    <NumberField
                        name="F107_quota_titolare"
                        label="Quota % titolare"
                        value={state.imposteContributi.F107_quota_titolare}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        forcedError={state.imposteContributi.F107_quota_titolare < 51}
                        forcedErrorMessage="La quota deve essere maggiore uguale di 51%"
                        symbol="%"
                        className={gClasses.textField}
                    />
                </Grid>
                <Typography style={{ marginTop: "1rem" }} variant="subtitle2">Collaboratore 1</Typography>
                <Grid container direction="row">
                    <NumberField
                        name="F108_quota_collab"
                        label="Quota % collab."
                        value={state.imposteContributi.F108_quota_collab}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={gClasses.textField}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel} 
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C108_21anni}
                                name='C108_21anni'
                                id='C108_21anni'
                                value={state.imposteContributi.C108_21anni}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Età < 21 anni" />
                </Grid>
                <Typography style={{ marginTop: "1rem" }} variant="subtitle2">Collaboratore 2</Typography>
                <Grid container direction="row">
                    <NumberField
                        name="F109_quota_collab"
                        label="Quota % collab."
                        value={state.imposteContributi.F109_quota_collab}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={gClasses.textField}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel} 
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C109_21anni}
                                name='C109_21anni'
                                id='C109_21anni'
                                value={state.imposteContributi.C109_21anni}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Età < 21 anni" />
                </Grid>
                <Typography style={{ marginTop: "1rem" }} variant="subtitle2">Collaboratore 3</Typography>
                <Grid container direction="row">
                    <NumberField
                        name="F110_quota_collab"
                        label="Quota % collab."
                        value={state.imposteContributi.F110_quota_collab}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={gClasses.textField}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel} 
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C110_21anni}
                                name='C110_21anni'
                                id='C110_21anni'
                                value={state.imposteContributi.C110_21anni}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Età < 21 anni" />
                </Grid>
                <Typography variant="subtitle2">Collaboratore 4</Typography>
                <Grid container direction="row">
                    <NumberField
                        name="F111_quota_collab"
                        label="Quota % collab."
                        value={state.imposteContributi.F111_quota_collab}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={gClasses.textField}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel} 
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C111_21anni}
                                name='C111_21anni'
                                id='C111_21anni'
                                value={state.imposteContributi.C111_21anni}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Età < 21 anni" />
                </Grid>
                <NumberField
                    name="F112_totale"
                    label="Totale"
                    value={state.imposteContributi.F112_totale}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    symbol="%"
                    forcedError={state.imposteContributi.F112_totale !== 100}
                    forcedErrorMessage="La quota totale è diversa da 100%"
                />
            </Grid>
            <Divider></Divider>
            <div>
                <SectionSubTitle text="Carichi familiari"></SectionSubTitle>
                <Typography variant="subtitle2">Titolare</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.H107_coniuge}
                            name='H107_coniuge'
                            id='H107_coniuge'
                            value={state.imposteContributi.H107_coniuge}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge" />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="nfigli">N. Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.I107_nfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'I107_nfigli', id: 'I107_nfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="pfigli">% Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.J107_pfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'J107_pfigli', id: 'J107_pfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div>
                <Typography variant="subtitle2">Collaboratore 1</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.H108_coniuge}
                            name='H108_coniuge'
                            id='H108_coniuge'
                            value={state.imposteContributi.H108_coniuge}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge" />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="nfigli_1">N. Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.I108_nfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'I108_nfigli', id: 'I108_nfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="pfigli_1">% Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.J108_pfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'J108_pfigli', id: 'J108_pfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div>
                <Typography variant="subtitle2">Collaboratore 2</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.H109_coniuge}
                            name='H109_coniuge'
                            id='H109_coniuge'
                            value={state.imposteContributi.H109_coniuge}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge" />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="nfigli_2">N. Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.I109_nfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'I109_nfigli', id: 'I109_nfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="pfigli_2">% Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.J109_pfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'J109_pfigli', id: 'J108_pfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div>
                <Typography variant="subtitle2">Collaboratore 3</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.H110_coniuge}
                            name='H110_coniuge'
                            id='H110_coniuge'
                            value={state.imposteContributi.H110_coniuge}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge"
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="nfigli_3">N. Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.I110_nfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'I110_nfigli', id: 'I110_nfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="pfigli_3">% Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.J110_pfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'J110_pfigli', id: 'J110_pfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div>
                <Typography variant="subtitle2">Collaboratore 4</Typography>
                <FormControlLabel className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.imposteContributi.H111_coniuge}
                            name='H111_coniuge'
                            id='H111_coniuge'
                            value={state.imposteContributi.H111_coniuge}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            onChange={handleChangeChecked}
                        />
                    }
                    label="Coniuge"
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="nfigli_4">N. Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.I111_nfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'I111_nfigli', id: 'I111_nfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={1}>1</MenuItem>
                        <MenuItem value={2}>2</MenuItem>
                        <MenuItem value={3}>3</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="pfigli_4">% Figli</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.imposteContributi.J111_pfigli}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'J111_pfigli', id: 'J111_pfigli' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={50}>50%</MenuItem>
                        <MenuItem value={100}>100%</MenuItem>
                    </Select>
                </FormControl>
            </div>
        </Paper>
    )
}